"use client";

import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ElectricBulls() {
  const shouldReduceMotion = useReducedMotion();
  const transitionEase = [0.16, 1, 0.3, 1] as const;
  const contentVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 12
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.3,
        ease: transitionEase
      }
    }
  };
  return <section id="electric-bulls-for-sale" data-nav="light" className="w-full border-b border-border bg-background py-14 md:py-20 text-foreground">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} variants={contentVariants} className="border border-border bg-card p-6 sm:p-8 md:p-12 shadow-xs">
          {/* Main Heading */}
          <h2 className="mb-8 font-serif text-3xl font-bold uppercase tracking-tight text-card-foreground sm:text-4xl md:text-5xl">
            Electric Bulls for Sale
          </h2>

          {/* Narrative Paragraphs */}
          <div className="mb-10 space-y-5 font-sans text-base leading-relaxed text-muted-foreground sm:text-lg">
            <p>
              An electric bull for sale uses powered motion and an operator control system, but different machines can use different motors, controllers, power requirements and operating modes. Some packages also include an inflatable safety arena and blower, while others may be configured differently.
            </p>
            <p>
              When comparing an electric mechanical bull for sale, look at the exact machine rather than assuming every electric bull works the same way. Check its controller, motion system, emergency-stop features, operating footprint and published electrical requirements. You should also confirm what comes with the package, including the inflatable area and blower where applicable.
            </p>
            <p>
              For machines built around an inflatable safety arena, see our{" "}
              <Link to="/InflatableMechanicalBullsPage" className="text-primary underline underline-offset-4 hover:text-primary/80">
                Inflatable Mechanical Bulls page
              </Link>{" "}
              for package-specific buying guidance.
            </p>
            <p className="border-l-2 border-primary/60 pl-4 text-foreground/90 font-medium">
              Mechanical Bull Shop keeps these details on the individual product pages so buyers can compare the actual equipment rather than relying on one generic specification for every model.
            </p>
          </div>

          {/* Primary CTA Anchor */}
          <div className="pt-2">
            <motion.div className="inline-block" whileTap={shouldReduceMotion ? undefined : {
            scale: 0.99
          }}>
              <Button asChild className="h-12 rounded-none bg-primary px-7 font-serif text-sm font-bold tracking-wider text-primary-foreground uppercase shadow-xs transition-[background-color,border-color,box-shadow] hover:bg-primary/90 focus-visible:ring-2 focus-visible:ring-ring">
                <Link to="#product-catalog" className="inline-flex items-center gap-2.5">
                  <span>COMPARE ELECTRIC MECHANICAL BULLS</span>
                  <ArrowRight className="size-4" aria-hidden="true" />
                </Link>
              </Button>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}